import { ButtonBlock } from '@coast/schemas';
import React, { useContext } from 'react';
import { View } from '@shared/components/View';
import { CardRenderContext } from '@shared/components/blocks/contexts/render';
import { MBButtonBlockButton } from './button';

interface Props {
  block: ButtonBlock;
  card: MBAPI.Card;
}

export function MBButtonBlock({ block: { buttons }, card }: Props) {
  const renderContext = useContext(CardRenderContext);
  return (
    <View
      center={buttons.length === 1}
      row
      paddingVertical={renderContext === 'detail' ? 2 : 1}
      paddingHorizontal={renderContext === 'detail' ? 3 : 2}
    >
      {buttons.map((button, idx) => (
        <MBButtonBlockButton key={idx} button={button} card={card} />
      ))}
    </View>
  );
}
